
document.addEventListener("DOMContentLoaded", () => {

  /* =====================================
     FAQ ACCORDION (runs only if FAQ exists)
  ===================================== */
  const faqItems = document.querySelectorAll(".faq-item");

  if (faqItems.length > 0) {
    faqItems.forEach(item => {
      const btn = item.querySelector(".faq-question");
      const icon = item.querySelector(".faq-icon");

      btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        // Close all items
        faqItems.forEach(i => {
          i.classList.remove("open");
          const ic = i.querySelector(".faq-icon");
          if (ic) ic.textContent = "+";
        });

        // Toggle the clicked one
        if (!isOpen) {
          item.classList.add("open");
          if (icon) icon.textContent = "−";
        }
      });
    });
  }


  /* =====================================
     REVEAL ANIMATION (smooth + optimized)
  ===================================== */
  const revealItems = document.querySelectorAll(".reveal-scale, .reveal-fade");

  if (revealItems.length > 0) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 } // smoother trigger
    );

    revealItems.forEach(el => observer.observe(el));
  }

});


document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".key-benefits-container");
  const onScroll = () => {
    const sectionTop = section.getBoundingClientRect().top;
    if (sectionTop < window.innerHeight - 100) {
      section.classList.add("show");
      window.removeEventListener("scroll", onScroll);
    }
  };
  window.addEventListener("scroll", onScroll);
  onScroll();
});